import { createContext } from 'react';
import { CardNavigationSubtable } from '@shared/scenes/cards/navigation';

/**
 * The card update form's subtable routes: a subtable's expanded modal and the row open over the
 * field or the modal live in the URL, so they survive a trip to a related card and back, browser
 * back and refresh. Unset where the form has no such routes (another host, the Create form), and
 * the modal and rows open from local state instead.
 */
export interface SubtableRoute {
  /** The subtable the URL has open. */
  subtable?: CardNavigationSubtable;
  /**
   * Opens a subtable's modal or row, or with undefined closes them, in place of the current history
   * entry, so stepping between rows adds none.
   */
  navigate: (subtable: CardNavigationSubtable | undefined) => void;
}

export const SubtableRouteContext = createContext<SubtableRoute | undefined>(undefined);
